module.exports = __webpack_public_path__ + "d8babb2b98e57ef43cf967846a63449c.png";